import type { DeepRequired } from '../fixtures.types'

const documentVerificationCp: DeepRequired<DocumentVerificationCp> = {
  __typename: 'DocumentVerificationCp',
  document_id: null,
  verification_date: null,
  verification_type: null,
  client_id: null,
  result_justification: [],
}

export default documentVerificationCp
